import RootState from 'typings/RootState'
import { createSelector } from 'reselect'
import { Imagelist } from './types'
import { Event } from '../../types/event'

export const selectData = (state: RootState): Imagelist =>
  state.reportImage.data

export const selectEvent = (state: RootState): Event =>
  state.reportImage.event
